export default __webpack_public_path__ + "static/media/mana20.b4d9903b.svg";